/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_analysis.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions Analysis */
HafasWebapp.prototype.subscriptions.analysis = function (_me) {

  Hafas.ps.sub('/analysis/init', Hafas.bind(_me.Controller.Analysis.init, _me));
  Hafas.ps.sub('/analysis/get/statist', Hafas.bind(_me.Controller.Analysis.downloadStat, _me));
  Hafas.ps.sub('/analysis/set/keyword', Hafas.bind(_me.Controller.Analysis.setStatistKeyword, _me));
  Hafas.ps.sub('/analysis/set/hciResponse', Hafas.bind(_me.Controller.Analysis.setHCIResponse, _me));
  Hafas.ps.sub('/analysis/clear/result', Hafas.bind(_me.Controller.Analysis.clearStatistResult, _me));
  Hafas.ps.sub('/analysis/clear/results/all', Hafas.bind(_me.Controller.Analysis.clearStatistList, _me));

};